import React from "react";

import Button from "../../components/Button";

export default function FourOFour({ onBackPress }) {
  return (
    <div className="text-center flex flex-col justify-center items-center px-8 pt-8 mx-auto max-w-4xl">
      <h1 className="text-4xl mb-4">404</h1>
      <h2 className="text-2xl mb-4 leading-snug">Did you get lost?</h2>
      <h2 className="text-lg mb-4">
        The page you are looking for does not exist.
      </h2>
      <div className="mb-4">
        <Button size="xl" variant="dark" onPress={onBackPress}>
          Back to GoNoodle
        </Button>
      </div>
      <img
        className="object-contain w-[226px] h-[394px]"
        src="https://cdn.gonoodle.com/Universe-Component-Library/general/squatchy-shrug.png"
        alt=""
      />
      <div className="mt-4">
        Still having trouble? Contact{" "}
        <a className="font-bold underline" href="mailto:support@gonoodle.com">
          support@gonoodle.com.
        </a>
      </div>
    </div>
  );
}

FourOFour.propTypes = {
  onBackPress: () => {},
};

FourOFour.defaultProps = {
  onBackPress: () => {},
};
